Select or click Next<template>
  <div class="col-md-3 col-xl-2 position-static px-0 px-md-15 pl-xl-0">
    <ul
      class="search-navigation style2 d-flex justify-content-md-end flex-wrap list-unstyled font-weight-medium mb-0"
    >
      <li class="nav-item open-close position-static">
        <a
          class="nav-link drop-opener d-flex justify-content-between align-items-center px-10 px-md-15"
          href="#"
        >
          Guided Search
          <span class="icon-chevron ml-10"></span>
        </a>
        <div class="dropdown border-top-0">
          <section class="steps-section js-steps-section" :data-url="search_link">
            <div data-step="targets[]" class="guided-search step-1 text-white text-center bg-stretch">
              <span :data-srcset="GuidedSearchBG1S"></span>
              <span :data-srcset="GuidedSearchBG1M" data-media="(min-width: 768px)"></span>
              <span :data-srcset="GuidedSearchBG1L" data-media="(min-width: 1024px)"></span>
              <div class="container pt-10 pb-15 py-md-25">
                <div class="row">
                  <div class="col-12">
                    <h2 class="font-weight-normal mb-0 mb-md-5">Who is going to use the resources?</h2>
                    <span class="info-text d-block mb-10 mb-md-30">(Select or click Next)</span>
                    <ul class="row steps-list list-unstyled">
                      <li v-for="item in targets" :key="item.id" class="col-6 col-md-3 pb-15 pb-md-30">
                        <a href="#" class="btn btn-white px-0 w-100">{{item.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div data-step="fluencies[]" class="guided-search step-2 text-white text-center bg-stretch">
              <span :data-srcset="GuidedSearchBG2S"></span>
              <span :data-srcset="GuidedSearchBG2M" data-media="(min-width: 768px)"></span>
              <span :data-srcset="GuidedSearchBG2L" data-media="(min-width: 1024px)"></span>
              <div class="container pt-10 pb-15 py-md-25">
                <div class="row">
                  <div class="col-12">
                    <h2
                      class="font-weight-normal mb-0 mb-md-5"
                    >What level of fluency would you like the resource to be?</h2>
                    <span class="info-text d-block mb-10 mb-md-30">(Select or click Next)</span>
                    <ul class="row steps-list list-unstyled">
                      <li v-for="item in fluencies" :key="item.id" class="col-6 col-md-3 pb-15 pb-md-30">
                        <a href="#" class="btn btn-white px-0 w-100">{{item.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div data-step="types[]" class="guided-search step-3 text-white text-center bg-stretch">
              <span :data-srcset="GuidedSearchBG3S"></span>
              <span :data-srcset="GuidedSearchBG3M" data-media="(min-width: 768px)"></span>
              <span :data-srcset="GuidedSearchBG3L" data-media="(min-width: 1024px)"></span>
              <div class="container pt-10 pb-15 py-md-25">
                <div class="row">
                  <div class="col-12">
                    <h2
                      class="font-weight-normal mb-0 mb-md-5"
                    >What type of resource are you looking for?</h2>
                    <span class="info-text d-block mb-10 mb-md-30">(Select or click Next)</span>
                    <ul class="row steps-list list-unstyled mb-125 mb-md-0">
                      <li v-for="item in types" :key="item.id" class="col-6 col-md-3 pb-15 pb-md-30">
                        <a href="#" class="btn btn-white px-0 w-100">{{item.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div data-step="classifications[]" class="guided-search step-4 text-white text-center bg-stretch">
              <span :data-srcset="GuidedSearchBG4S"></span>
              <span :data-srcset="GuidedSearchBG4M" data-media="(min-width: 768px)"></span>
              <span :data-srcset="GuidedSearchBG4L" data-media="(min-width: 1024px)"></span>
              <div class="container pt-10 pb-15 py-md-25">
                <div class="row">
                  <div class="col-12">
                    <h2
                      class="font-weight-normal mb-0 mb-md-5"
                    >Do any of these topics relate to your search?</h2>
                    <span class="info-text d-block mb-10 mb-md-30">(Select or click Next)</span>
                    <ul class="row steps-list list-unstyled mb-0">
                      <li v-for="item in classifications" :key="item.id" class="col-6 col-md-3 pb-15 pb-md-30">
                        <a href="#" class="btn btn-white px-0 w-100">
                          {{item.name}} 
                          </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div data-step="languages[]" class="guided-search step-5 text-white text-center bg-stretch">
              <span :data-srcset="GuidedSearchBG5S"></span>
              <span :data-srcset="GuidedSearchBG5M" data-media="(min-width: 768px)"></span>
              <span :data-srcset="GuidedSearchBG5L" data-media="(min-width: 1024px)"></span>
              <div class="container pt-10 pb-15 py-md-25">
                <div class="row">
                  <div class="col-12">
                    <h2
                      class="font-weight-normal mb-0 mb-md-5"
                    >Which language would you prefer the resource in?</h2>
                    <span class="info-text d-block mb-10 mb-md-30">(Select or click Search)</span>
                    <ul class="row steps-list list-unstyled">
                      <li v-for="item in languages" :key="item.id" class="col-6 col-md-3 pb-15 pb-md-30">
                        <a href="#" class="btn btn-white px-0 w-100">{{item.name}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="skip-next">
              <div class="container">
                <div class="row justify-content-end">
                  <div class="col-6 col-md-3">
                    <a href="#" class="btn btn-primary w-100 next-step">next</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </li>
    </ul>
  </div>
</template>
<style scoped lang="scss">
</style>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([
      "search_link",
      "types",
      "classifications",
      "targets",
      "languages",
      "fluencies"
    ])
  },
  data() {
    return {
      GuidedSearchBG1S: `${window.GuidedSearchBG1S}, ${window.GuidedSearchBG1S} 2x`,
      GuidedSearchBG1M: `${window.GuidedSearchBG1M}, ${window.GuidedSearchBG1M} 2x`,
      GuidedSearchBG1L: `${window.GuidedSearchBG1L}, ${window.GuidedSearchBG1L} 2x`,
      GuidedSearchBG2S: `${window.GuidedSearchBG2S}, ${window.GuidedSearchBG2S} 2x`,
      GuidedSearchBG2M: `${window.GuidedSearchBG2M}, ${window.GuidedSearchBG2M} 2x`,
      GuidedSearchBG2L: `${window.GuidedSearchBG2L}, ${window.GuidedSearchBG2L} 2x`,
      GuidedSearchBG3S: `${window.GuidedSearchBG3S}, ${window.GuidedSearchBG3S} 2x`,
      GuidedSearchBG3M: `${window.GuidedSearchBG3M}, ${window.GuidedSearchBG3M} 2x`,
      GuidedSearchBG3L: `${window.GuidedSearchBG3L}, ${window.GuidedSearchBG3L} 2x`,
      GuidedSearchBG4S: `${window.GuidedSearchBG4S}, ${window.GuidedSearchBG4S} 2x`,
      GuidedSearchBG4M: `${window.GuidedSearchBG4M}, ${window.GuidedSearchBG4M} 2x`,
      GuidedSearchBG4L: `${window.GuidedSearchBG4L}, ${window.GuidedSearchBG4L} 2x`,
      GuidedSearchBG5S: `${window.GuidedSearchBG5S}, ${window.GuidedSearchBG5S} 2x`,
      GuidedSearchBG5M: `${window.GuidedSearchBG5M}, ${window.GuidedSearchBG5M} 2x`,
      GuidedSearchBG5L: `${window.GuidedSearchBG5L}, ${window.GuidedSearchBG5L} 2x`
    };
  },

  mounted() {

  }
};
</script>
